<template>
    <modal name="referensiPenjual" :draggable="false" :scrollable="true" :height="'auto'">
        <div class="modal fade show " tabindex="-1" style="display: block;margin-top: 2%;" aria-modal="true" role="dialog">
            <div class="modal-dialog  modal-xl">
                <div class="modal-content">

                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel"> {{ $t("referensi_pemilik_barang") }} </h5>
                        <button type="button" class="btn btn-default" @click.prevent="removeModals()" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <div class="modal-body">

                        <vue-good-table title="exim-ceisa-pengirim-list" ref="exim-ceisa-pengirim-list" mode="remote"
                            @on-page-change="onPageChangePengirim" @on-sort-change="onSortChangePengirim"
                            @on-column-filter="onColumnFilterPengirim" @on-per-page-change="onPerPageChangePengirim"
                            :totalRows="totalRecordsPengirim" :line-numbers="true" :isLoading.sync="isLoadingPengirim"
                            :pagination-options="{

                                enabled: true,
                                perPageDropdown: [10, 50, 100, 1000, 10000],
                                dropdownAllowAll: false,
                            }" :rows="rowsPengirim" :columns="columnsPengirim">



                            <template slot="table-row" slot-scope="props">
                                <span v-if="props.column.field == 'actions'">
                                    <a href="#" title="Add" @click.prevent="addDataPengirim(props.index, props.row)">
                                        <i class="mdi mdi-bookmark-plus" style="font-size:16px"></i>
                                    </a>
                                </span>
                                <span v-else>
                                    {{ props.formattedRow[props.column.field] }}
                                </span>
                            </template>
                        </vue-good-table>


                    </div>


                    <div class="modal-footer justify-content-between">
                        <button type="button" class="btn btn-secondary"
                            @click.prevent="removeModals()">{{ this.$t("close_txt") }}</button>
                    </div>


                </div>
            </div>
        </div>
    </modal>
</template>

<script>
export default {
    name: "modalReferensiPenjual",
    data() {
        return {
            serverParamsPengirim: {
                columnFilters: {},
                sort: {
                    field: "",
                    type: "",
                },
                page: 1,
                per_page: 10,
            },


            totalRecordsPengirim: 0,
            rowsPengirim: [],
            detailDokumen: [],
            columnsPengirim: [

                {
                    label: this.$t('name'),
                    field: "name",
                    thClass: 'text-center',
                    filterOptions: {
                            customFilter: false,
                            enabled: true, // enable filter for this column
                            placeholder: '', // placeholder for filter input
                            filterValue: "", // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            trigger: "enter", //only trigger on enter not on keyup
                        },
                },

                {
                    label: this.$t('countryTxt'),
                    field: "country",
                    thClass: 'text-center',
                    filterOptions: {
                            customFilter: false,
                            enabled: true, // enable filter for this column
                            placeholder: '', // placeholder for filter input
                            filterValue: "", // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            trigger: "enter", //only trigger on enter not on keyup
                        },
                },


                {
                    label: this.$t('identity_number'),
                    field: "identity_number",
                    thClass: 'text-center',
                    filterOptions: {
                        customFilter: false,
                        enabled: true, // enable filter for this column
                        placeholder: '', // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },

                
                
                {
                    label: this.$t('nib'),
                    field: "nib", 
                    filterOptions: {
                    customFilter: false,
                        enabled: true, // enable filter for this column
                        placeholder: "", // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], 
                        trigger: "enter", //only trigger on enter not on keyup
                    },

                },

                {
                    label: this.$t("action_txt"),
                    field: "actions",
                    thClass: 'text-center',
                    sortable: false,
                    filterOptions: {
                    customFilter: false,
                    }
                },

            ],
        }
    },
    methods: {

        addDataPengirim(index, row) {
            this.$emit("setValue", row);
            this.removeModals();
        },

        // load items pemilik barang
        loadItemsPengirim() {
            const baseURI = this.$settings.endPointCeisa + "v1/customer/index";
            this.isLoadingPengirim = true;
            
            return this.$http
            .get(
                baseURI +
                `?limit=${this.serverParamsPengirim.per_page}&page=${this.serverParamsPengirim.page}&sort_field=${this.serverParamsPengirim.sort.field}&sort_type=${this.serverParamsPengirim.sort.type}&name=${this.serverParamsPengirim.columnFilters.name}&country=${this.serverParamsPengirim.columnFilters.country}&identity_number=${this.serverParamsPengirim.columnFilters.identity_number}&nib=${this.serverParamsPengirim.columnFilters.nib}&type=PENJUAL`,
                { timeout: 120000 })
            .then((response) => {

                this.isLoadingPengirim      = false;
                this.rowsPengirim           = response.data.datas.data;
                this.totalRecordsPengirim   = response.data.datas.total;

            }).catch((error) => {
                this.loading();
    
                if (error.code == "ECONNABORTED") {
                this.error(this.$t("check_internet_connection_txt"));
    
                } else {
    
                if (error.response) {
                    if (error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                    } else if (error.response.status === 401) {
                    this.logout();
                    } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                    } else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                    } else {
                    this.$router.push('/page-not-found');
                    }
                }
    
                }
            });
        },

        updateParamsPengirim(newProps) {
            this.serverParamsPengirim = Object.assign({}, this.serverParamsPengirim, newProps);
            this.loadItemsPengirim();
        },
  
        onColumnFilterPengirim(params) {
            this.updateParamsPengirim(params);
        },
    
        onPageChangePengirim(params) {
            this.updateParamsPengirim({ page: params.currentPage });
        },
    
        onSortChangePengirim(params) {
            this.updateParamsPengirim({
            sort: {
                type: params[0].type,
                field: params[0].field,
            },
            });
        },
  
        onPerPageChangePengirim(params) {
            this.updateParamsPengirim({ per_page: params.currentPerPage });
        },

        removeModals() {
            this.$modal.hide('referensiPenjual');
            
        }
    },
    created: function () {
        this.loadItemsPengirim();
    }
}
</script>

<style></style>